import { render } from "./IconsDemo.vue?vue&type=template&id=b1965c78&scoped=true"
import script from "./IconsDemo.vue?vue&type=script&lang=js"
export * from "./IconsDemo.vue?vue&type=script&lang=js"

import "./IconsDemo.vue?vue&type=style&index=0&id=b1965c78&lang=scss&scoped=true"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1965c78"]])

export default __exports__